/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerificationLinksRouteImport } from './routes/verification-links'
import { Route as TransactionsRouteImport } from './routes/transactions'
import { Route as TosRouteImport } from './routes/tos'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TeamRouteImport } from './routes/team'
import { Route as SubmissionsRouteImport } from './routes/submissions'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as R2ControlsRouteImport } from './routes/r2-controls'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PassportsRouteImport } from './routes/passports'
import { Route as OpportunitiesRouteImport } from './routes/opportunities'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as OffersRouteImport } from './routes/offers'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as MatchesRouteImport } from './routes/matches'
import { Route as MarketplaceRouteImport } from './routes/marketplace'
import { Route as MarketTrendsRouteImport } from './routes/market-trends'
import { Route as MarketIntelligenceRouteImport } from './routes/market-intelligence'
import { Route as LotsRouteImport } from './routes/lots'
import { Route as LocationsRouteImport } from './routes/locations'
import { Route as ListingsRouteImport } from './routes/listings'
import { Route as InventoryMarginRouteImport } from './routes/inventory-margin'
import { Route as InventoryRouteImport } from './routes/inventory'
import { Route as IntegrationsRouteImport } from './routes/integrations'
import { Route as IndividualProfileRouteImport } from './routes/individual-profile'
import { Route as FinancialsRouteImport } from './routes/financials'
import { Route as EnvironmentalRouteImport } from './routes/environmental'
import { Route as DirectOffersRouteImport } from './routes/direct-offers'
import { Route as DataHealthRouteImport } from './routes/data-health'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CustomsRouteImport } from './routes/customs'
import { Route as CustodyAuditRecordsRouteImport } from './routes/custody-audit-records'
import { Route as CarbonMethodologyRouteImport } from './routes/carbon-methodology'
import { Route as AssetsRouteImport } from './routes/assets'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TransactionsIndexRouteImport } from './routes/transactions/index'
import { Route as SubmissionsIndexRouteImport } from './routes/submissions/index'
import { Route as MarketIntelligenceIndexRouteImport } from './routes/market-intelligence/index'
import { Route as FinancialsIndexRouteImport } from './routes/financials/index'
import { Route as EnvironmentalIndexRouteImport } from './routes/environmental/index'
import { Route as AssetsIndexRouteImport } from './routes/assets/index'
import { Route as TransactionsTransactionIdRouteImport } from './routes/transactions/$transactionId'
import { Route as SubmissionsSubmissionIdRouteImport } from './routes/submissions/$submissionId'
import { Route as PassportFingerprintRouteImport } from './routes/passport.$fingerprint'
import { Route as MarketIntelligenceCostSettingsRouteImport } from './routes/market-intelligence/cost-settings'
import { Route as MarketIntelligenceAnalysisIdRouteImport } from './routes/market-intelligence/$analysisId'
import { Route as LotsLotIdRouteImport } from './routes/lots_.$lotId'
import { Route as ListingsListingIdRouteImport } from './routes/listings_.$listingId'
import { Route as ImportBatchIdRouteImport } from './routes/import/$batchId'
import { Route as FinancialsSustainabilityRouteImport } from './routes/financials/sustainability'
import { Route as FinancialsSetupRouteImport } from './routes/financials/setup'
import { Route as FinancialsScenariosRouteImport } from './routes/financials/scenarios'
import { Route as FinancialsPolicyRouteImport } from './routes/financials/policy'
import { Route as FinancialsOpportunityRouteImport } from './routes/financials/opportunity'
import { Route as FinancialsDepreciationRouteImport } from './routes/financials/depreciation'
import { Route as FinancialsBookVsFmvRouteImport } from './routes/financials/book-vs-fmv'
import { Route as FinancialsAssetFinancialsRouteImport } from './routes/financials/asset-financials'
import { Route as EnvironmentalReportsRouteImport } from './routes/environmental/reports'
import { Route as EnvironmentalFleetDetailRouteImport } from './routes/environmental/fleet-detail'
import { Route as EnvironmentalCircularityRouteImport } from './routes/environmental/circularity'
import { Route as BenchPairRouteImport } from './routes/bench/pair'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AssetsSubmitRouteImport } from './routes/assets/submit'
import { Route as AssetsAssetIdRouteImport } from './routes/assets/$assetId'
import { Route as FinancialsScenariosIndexRouteImport } from './routes/financials/scenarios/index'
import { Route as BenchRunsIndexRouteImport } from './routes/bench/runs/index'
import { Route as BenchPlansIndexRouteImport } from './routes/bench/plans/index'
import { Route as FinancialsTriageBatchIdRouteImport } from './routes/financials/triage.$batchId'
import { Route as FinancialsScenariosScenarioIdRouteImport } from './routes/financials/scenarios/$scenarioId'
import { Route as BenchRunsRunIdRouteImport } from './routes/bench/runs/$runId'
import { Route as BenchPlansNewRouteImport } from './routes/bench/plans/new'
import { Route as BenchPlansPlanIdRouteImport } from './routes/bench/plans/$planId'

const VerificationLinksRoute = VerificationLinksRouteImport.update({
  id: '/verification-links',
  path: '/verification-links',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsRoute = TransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const TosRoute = TosRouteImport.update({
  id: '/tos',
  path: '/tos',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamRoute = TeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => rootRouteImport,
} as any)
const SubmissionsRoute = SubmissionsRouteImport.update({
  id: '/submissions',
  path: '/submissions',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const R2ControlsRoute = R2ControlsRouteImport.update({
  id: '/r2-controls',
  path: '/r2-controls',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PassportsRoute = PassportsRouteImport.update({
  id: '/passports',
  path: '/passports',
  getParentRoute: () => rootRouteImport,
} as any)
const OpportunitiesRoute = OpportunitiesRouteImport.update({
  id: '/opportunities',
  path: '/opportunities',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const OffersRoute = OffersRouteImport.update({
  id: '/offers',
  path: '/offers',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const MatchesRoute = MatchesRouteImport.update({
  id: '/matches',
  path: '/matches',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketplaceRoute = MarketplaceRouteImport.update({
  id: '/marketplace',
  path: '/marketplace',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketTrendsRoute = MarketTrendsRouteImport.update({
  id: '/market-trends',
  path: '/market-trends',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketIntelligenceRoute = MarketIntelligenceRouteImport.update({
  id: '/market-intelligence',
  path: '/market-intelligence',
  getParentRoute: () => rootRouteImport,
} as any)
const LotsRoute = LotsRouteImport.update({
  id: '/lots',
  path: '/lots',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationsRoute = LocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => rootRouteImport,
} as any)
const ListingsRoute = ListingsRouteImport.update({
  id: '/listings',
  path: '/listings',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryMarginRoute = InventoryMarginRouteImport.update({
  id: '/inventory-margin',
  path: '/inventory-margin',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryRoute = InventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsRoute = IntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const IndividualProfileRoute = IndividualProfileRouteImport.update({
  id: '/individual-profile',
  path: '/individual-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const FinancialsRoute = FinancialsRouteImport.update({
  id: '/financials',
  path: '/financials',
  getParentRoute: () => rootRouteImport,
} as any)
const EnvironmentalRoute = EnvironmentalRouteImport.update({
  id: '/environmental',
  path: '/environmental',
  getParentRoute: () => rootRouteImport,
} as any)
const DirectOffersRoute = DirectOffersRouteImport.update({
  id: '/direct-offers',
  path: '/direct-offers',
  getParentRoute: () => rootRouteImport,
} as any)
const DataHealthRoute = DataHealthRouteImport.update({
  id: '/data-health',
  path: '/data-health',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomsRoute = CustomsRouteImport.update({
  id: '/customs',
  path: '/customs',
  getParentRoute: () => rootRouteImport,
} as any)
const CustodyAuditRecordsRoute = CustodyAuditRecordsRouteImport.update({
  id: '/custody-audit-records',
  path: '/custody-audit-records',
  getParentRoute: () => rootRouteImport,
} as any)
const CarbonMethodologyRoute = CarbonMethodologyRouteImport.update({
  id: '/carbon-methodology',
  path: '/carbon-methodology',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsRoute = AssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsIndexRoute = TransactionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TransactionsRoute,
} as any)
const SubmissionsIndexRoute = SubmissionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SubmissionsRoute,
} as any)
const MarketIntelligenceIndexRoute = MarketIntelligenceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MarketIntelligenceRoute,
} as any)
const FinancialsIndexRoute = FinancialsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FinancialsRoute,
} as any)
const EnvironmentalIndexRoute = EnvironmentalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EnvironmentalRoute,
} as any)
const AssetsIndexRoute = AssetsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AssetsRoute,
} as any)
const TransactionsTransactionIdRoute =
  TransactionsTransactionIdRouteImport.update({
    id: '/$transactionId',
    path: '/$transactionId',
    getParentRoute: () => TransactionsRoute,
  } as any)
const SubmissionsSubmissionIdRoute = SubmissionsSubmissionIdRouteImport.update({
  id: '/$submissionId',
  path: '/$submissionId',
  getParentRoute: () => SubmissionsRoute,
} as any)
const PassportFingerprintRoute = PassportFingerprintRouteImport.update({
  id: '/passport/$fingerprint',
  path: '/passport/$fingerprint',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketIntelligenceCostSettingsRoute =
  MarketIntelligenceCostSettingsRouteImport.update({
    id: '/cost-settings',
    path: '/cost-settings',
    getParentRoute: () => MarketIntelligenceRoute,
  } as any)
const MarketIntelligenceAnalysisIdRoute =
  MarketIntelligenceAnalysisIdRouteImport.update({
    id: '/$analysisId',
    path: '/$analysisId',
    getParentRoute: () => MarketIntelligenceRoute,
  } as any)
const LotsLotIdRoute = LotsLotIdRouteImport.update({
  id: '/lots_/$lotId',
  path: '/lots/$lotId',
  getParentRoute: () => rootRouteImport,
} as any)
const ListingsListingIdRoute = ListingsListingIdRouteImport.update({
  id: '/listings_/$listingId',
  path: '/listings/$listingId',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportBatchIdRoute = ImportBatchIdRouteImport.update({
  id: '/import/$batchId',
  path: '/import/$batchId',
  getParentRoute: () => rootRouteImport,
} as any)
const FinancialsSustainabilityRoute =
  FinancialsSustainabilityRouteImport.update({
    id: '/sustainability',
    path: '/sustainability',
    getParentRoute: () => FinancialsRoute,
  } as any)
const FinancialsSetupRoute = FinancialsSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => FinancialsRoute,
} as any)
const FinancialsScenariosRoute = FinancialsScenariosRouteImport.update({
  id: '/scenarios',
  path: '/scenarios',
  getParentRoute: () => FinancialsRoute,
} as any)
const FinancialsPolicyRoute = FinancialsPolicyRouteImport.update({
  id: '/policy',
  path: '/policy',
  getParentRoute: () => FinancialsRoute,
} as any)
const FinancialsOpportunityRoute = FinancialsOpportunityRouteImport.update({
  id: '/opportunity',
  path: '/opportunity',
  getParentRoute: () => FinancialsRoute,
} as any)
const FinancialsDepreciationRoute = FinancialsDepreciationRouteImport.update({
  id: '/depreciation',
  path: '/depreciation',
  getParentRoute: () => FinancialsRoute,
} as any)
const FinancialsBookVsFmvRoute = FinancialsBookVsFmvRouteImport.update({
  id: '/book-vs-fmv',
  path: '/book-vs-fmv',
  getParentRoute: () => FinancialsRoute,
} as any)
const FinancialsAssetFinancialsRoute =
  FinancialsAssetFinancialsRouteImport.update({
    id: '/asset-financials',
    path: '/asset-financials',
    getParentRoute: () => FinancialsRoute,
  } as any)
const EnvironmentalReportsRoute = EnvironmentalReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => EnvironmentalRoute,
} as any)
const EnvironmentalFleetDetailRoute =
  EnvironmentalFleetDetailRouteImport.update({
    id: '/fleet-detail',
    path: '/fleet-detail',
    getParentRoute: () => EnvironmentalRoute,
  } as any)
const EnvironmentalCircularityRoute =
  EnvironmentalCircularityRouteImport.update({
    id: '/circularity',
    path: '/circularity',
    getParentRoute: () => EnvironmentalRoute,
  } as any)
const BenchPairRoute = BenchPairRouteImport.update({
  id: '/bench/pair',
  path: '/bench/pair',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsSubmitRoute = AssetsSubmitRouteImport.update({
  id: '/submit',
  path: '/submit',
  getParentRoute: () => AssetsRoute,
} as any)
const AssetsAssetIdRoute = AssetsAssetIdRouteImport.update({
  id: '/$assetId',
  path: '/$assetId',
  getParentRoute: () => AssetsRoute,
} as any)
const FinancialsScenariosIndexRoute =
  FinancialsScenariosIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => FinancialsScenariosRoute,
  } as any)
const BenchRunsIndexRoute = BenchRunsIndexRouteImport.update({
  id: '/bench/runs/',
  path: '/bench/runs/',
  getParentRoute: () => rootRouteImport,
} as any)
const BenchPlansIndexRoute = BenchPlansIndexRouteImport.update({
  id: '/bench/plans/',
  path: '/bench/plans/',
  getParentRoute: () => rootRouteImport,
} as any)
const FinancialsTriageBatchIdRoute = FinancialsTriageBatchIdRouteImport.update({
  id: '/triage/$batchId',
  path: '/triage/$batchId',
  getParentRoute: () => FinancialsRoute,
} as any)
const FinancialsScenariosScenarioIdRoute =
  FinancialsScenariosScenarioIdRouteImport.update({
    id: '/$scenarioId',
    path: '/$scenarioId',
    getParentRoute: () => FinancialsScenariosRoute,
  } as any)
const BenchRunsRunIdRoute = BenchRunsRunIdRouteImport.update({
  id: '/bench/runs/$runId',
  path: '/bench/runs/$runId',
  getParentRoute: () => rootRouteImport,
} as any)
const BenchPlansNewRoute = BenchPlansNewRouteImport.update({
  id: '/bench/plans/new',
  path: '/bench/plans/new',
  getParentRoute: () => rootRouteImport,
} as any)
const BenchPlansPlanIdRoute = BenchPlansPlanIdRouteImport.update({
  id: '/bench/plans/$planId',
  path: '/bench/plans/$planId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/assets': typeof AssetsRouteWithChildren
  '/carbon-methodology': typeof CarbonMethodologyRoute
  '/custody-audit-records': typeof CustodyAuditRecordsRoute
  '/customs': typeof CustomsRoute
  '/dashboard': typeof DashboardRoute
  '/data-health': typeof DataHealthRoute
  '/direct-offers': typeof DirectOffersRoute
  '/environmental': typeof EnvironmentalRouteWithChildren
  '/financials': typeof FinancialsRouteWithChildren
  '/individual-profile': typeof IndividualProfileRoute
  '/integrations': typeof IntegrationsRoute
  '/inventory': typeof InventoryRoute
  '/inventory-margin': typeof InventoryMarginRoute
  '/listings': typeof ListingsRoute
  '/locations': typeof LocationsRoute
  '/lots': typeof LotsRoute
  '/market-intelligence': typeof MarketIntelligenceRouteWithChildren
  '/market-trends': typeof MarketTrendsRoute
  '/marketplace': typeof MarketplaceRoute
  '/matches': typeof MatchesRoute
  '/notifications': typeof NotificationsRoute
  '/offers': typeof OffersRoute
  '/onboarding': typeof OnboardingRoute
  '/opportunities': typeof OpportunitiesRoute
  '/passports': typeof PassportsRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/r2-controls': typeof R2ControlsRoute
  '/signup': typeof SignupRoute
  '/submissions': typeof SubmissionsRouteWithChildren
  '/team': typeof TeamRoute
  '/terms': typeof TermsRoute
  '/tos': typeof TosRoute
  '/transactions': typeof TransactionsRouteWithChildren
  '/verification-links': typeof VerificationLinksRoute
  '/assets/$assetId': typeof AssetsAssetIdRoute
  '/assets/submit': typeof AssetsSubmitRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/bench/pair': typeof BenchPairRoute
  '/environmental/circularity': typeof EnvironmentalCircularityRoute
  '/environmental/fleet-detail': typeof EnvironmentalFleetDetailRoute
  '/environmental/reports': typeof EnvironmentalReportsRoute
  '/financials/asset-financials': typeof FinancialsAssetFinancialsRoute
  '/financials/book-vs-fmv': typeof FinancialsBookVsFmvRoute
  '/financials/depreciation': typeof FinancialsDepreciationRoute
  '/financials/opportunity': typeof FinancialsOpportunityRoute
  '/financials/policy': typeof FinancialsPolicyRoute
  '/financials/scenarios': typeof FinancialsScenariosRouteWithChildren
  '/financials/setup': typeof FinancialsSetupRoute
  '/financials/sustainability': typeof FinancialsSustainabilityRoute
  '/import/$batchId': typeof ImportBatchIdRoute
  '/listings/$listingId': typeof ListingsListingIdRoute
  '/lots/$lotId': typeof LotsLotIdRoute
  '/market-intelligence/$analysisId': typeof MarketIntelligenceAnalysisIdRoute
  '/market-intelligence/cost-settings': typeof MarketIntelligenceCostSettingsRoute
  '/passport/$fingerprint': typeof PassportFingerprintRoute
  '/submissions/$submissionId': typeof SubmissionsSubmissionIdRoute
  '/transactions/$transactionId': typeof TransactionsTransactionIdRoute
  '/assets/': typeof AssetsIndexRoute
  '/environmental/': typeof EnvironmentalIndexRoute
  '/financials/': typeof FinancialsIndexRoute
  '/market-intelligence/': typeof MarketIntelligenceIndexRoute
  '/submissions/': typeof SubmissionsIndexRoute
  '/transactions/': typeof TransactionsIndexRoute
  '/bench/plans/$planId': typeof BenchPlansPlanIdRoute
  '/bench/plans/new': typeof BenchPlansNewRoute
  '/bench/runs/$runId': typeof BenchRunsRunIdRoute
  '/financials/scenarios/$scenarioId': typeof FinancialsScenariosScenarioIdRoute
  '/financials/triage/$batchId': typeof FinancialsTriageBatchIdRoute
  '/bench/plans/': typeof BenchPlansIndexRoute
  '/bench/runs/': typeof BenchRunsIndexRoute
  '/financials/scenarios/': typeof FinancialsScenariosIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/carbon-methodology': typeof CarbonMethodologyRoute
  '/custody-audit-records': typeof CustodyAuditRecordsRoute
  '/customs': typeof CustomsRoute
  '/dashboard': typeof DashboardRoute
  '/data-health': typeof DataHealthRoute
  '/direct-offers': typeof DirectOffersRoute
  '/individual-profile': typeof IndividualProfileRoute
  '/integrations': typeof IntegrationsRoute
  '/inventory': typeof InventoryRoute
  '/inventory-margin': typeof InventoryMarginRoute
  '/listings': typeof ListingsRoute
  '/locations': typeof LocationsRoute
  '/lots': typeof LotsRoute
  '/market-trends': typeof MarketTrendsRoute
  '/marketplace': typeof MarketplaceRoute
  '/matches': typeof MatchesRoute
  '/notifications': typeof NotificationsRoute
  '/offers': typeof OffersRoute
  '/onboarding': typeof OnboardingRoute
  '/opportunities': typeof OpportunitiesRoute
  '/passports': typeof PassportsRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/r2-controls': typeof R2ControlsRoute
  '/signup': typeof SignupRoute
  '/team': typeof TeamRoute
  '/terms': typeof TermsRoute
  '/tos': typeof TosRoute
  '/verification-links': typeof VerificationLinksRoute
  '/assets/$assetId': typeof AssetsAssetIdRoute
  '/assets/submit': typeof AssetsSubmitRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/bench/pair': typeof BenchPairRoute
  '/environmental/circularity': typeof EnvironmentalCircularityRoute
  '/environmental/fleet-detail': typeof EnvironmentalFleetDetailRoute
  '/environmental/reports': typeof EnvironmentalReportsRoute
  '/financials/asset-financials': typeof FinancialsAssetFinancialsRoute
  '/financials/book-vs-fmv': typeof FinancialsBookVsFmvRoute
  '/financials/depreciation': typeof FinancialsDepreciationRoute
  '/financials/opportunity': typeof FinancialsOpportunityRoute
  '/financials/policy': typeof FinancialsPolicyRoute
  '/financials/setup': typeof FinancialsSetupRoute
  '/financials/sustainability': typeof FinancialsSustainabilityRoute
  '/import/$batchId': typeof ImportBatchIdRoute
  '/listings/$listingId': typeof ListingsListingIdRoute
  '/lots/$lotId': typeof LotsLotIdRoute
  '/market-intelligence/$analysisId': typeof MarketIntelligenceAnalysisIdRoute
  '/market-intelligence/cost-settings': typeof MarketIntelligenceCostSettingsRoute
  '/passport/$fingerprint': typeof PassportFingerprintRoute
  '/submissions/$submissionId': typeof SubmissionsSubmissionIdRoute
  '/transactions/$transactionId': typeof TransactionsTransactionIdRoute
  '/assets': typeof AssetsIndexRoute
  '/environmental': typeof EnvironmentalIndexRoute
  '/financials': typeof FinancialsIndexRoute
  '/market-intelligence': typeof MarketIntelligenceIndexRoute
  '/submissions': typeof SubmissionsIndexRoute
  '/transactions': typeof TransactionsIndexRoute
  '/bench/plans/$planId': typeof BenchPlansPlanIdRoute
  '/bench/plans/new': typeof BenchPlansNewRoute
  '/bench/runs/$runId': typeof BenchRunsRunIdRoute
  '/financials/scenarios/$scenarioId': typeof FinancialsScenariosScenarioIdRoute
  '/financials/triage/$batchId': typeof FinancialsTriageBatchIdRoute
  '/bench/plans': typeof BenchPlansIndexRoute
  '/bench/runs': typeof BenchRunsIndexRoute
  '/financials/scenarios': typeof FinancialsScenariosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/assets': typeof AssetsRouteWithChildren
  '/carbon-methodology': typeof CarbonMethodologyRoute
  '/custody-audit-records': typeof CustodyAuditRecordsRoute
  '/customs': typeof CustomsRoute
  '/dashboard': typeof DashboardRoute
  '/data-health': typeof DataHealthRoute
  '/direct-offers': typeof DirectOffersRoute
  '/environmental': typeof EnvironmentalRouteWithChildren
  '/financials': typeof FinancialsRouteWithChildren
  '/individual-profile': typeof IndividualProfileRoute
  '/integrations': typeof IntegrationsRoute
  '/inventory': typeof InventoryRoute
  '/inventory-margin': typeof InventoryMarginRoute
  '/listings': typeof ListingsRoute
  '/locations': typeof LocationsRoute
  '/lots': typeof LotsRoute
  '/market-intelligence': typeof MarketIntelligenceRouteWithChildren
  '/market-trends': typeof MarketTrendsRoute
  '/marketplace': typeof MarketplaceRoute
  '/matches': typeof MatchesRoute
  '/notifications': typeof NotificationsRoute
  '/offers': typeof OffersRoute
  '/onboarding': typeof OnboardingRoute
  '/opportunities': typeof OpportunitiesRoute
  '/passports': typeof PassportsRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/r2-controls': typeof R2ControlsRoute
  '/signup': typeof SignupRoute
  '/submissions': typeof SubmissionsRouteWithChildren
  '/team': typeof TeamRoute
  '/terms': typeof TermsRoute
  '/tos': typeof TosRoute
  '/transactions': typeof TransactionsRouteWithChildren
  '/verification-links': typeof VerificationLinksRoute
  '/assets/$assetId': typeof AssetsAssetIdRoute
  '/assets/submit': typeof AssetsSubmitRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/bench/pair': typeof BenchPairRoute
  '/environmental/circularity': typeof EnvironmentalCircularityRoute
  '/environmental/fleet-detail': typeof EnvironmentalFleetDetailRoute
  '/environmental/reports': typeof EnvironmentalReportsRoute
  '/financials/asset-financials': typeof FinancialsAssetFinancialsRoute
  '/financials/book-vs-fmv': typeof FinancialsBookVsFmvRoute
  '/financials/depreciation': typeof FinancialsDepreciationRoute
  '/financials/opportunity': typeof FinancialsOpportunityRoute
  '/financials/policy': typeof FinancialsPolicyRoute
  '/financials/scenarios': typeof FinancialsScenariosRouteWithChildren
  '/financials/setup': typeof FinancialsSetupRoute
  '/financials/sustainability': typeof FinancialsSustainabilityRoute
  '/import/$batchId': typeof ImportBatchIdRoute
  '/listings_/$listingId': typeof ListingsListingIdRoute
  '/lots_/$lotId': typeof LotsLotIdRoute
  '/market-intelligence/$analysisId': typeof MarketIntelligenceAnalysisIdRoute
  '/market-intelligence/cost-settings': typeof MarketIntelligenceCostSettingsRoute
  '/passport/$fingerprint': typeof PassportFingerprintRoute
  '/submissions/$submissionId': typeof SubmissionsSubmissionIdRoute
  '/transactions/$transactionId': typeof TransactionsTransactionIdRoute
  '/assets/': typeof AssetsIndexRoute
  '/environmental/': typeof EnvironmentalIndexRoute
  '/financials/': typeof FinancialsIndexRoute
  '/market-intelligence/': typeof MarketIntelligenceIndexRoute
  '/submissions/': typeof SubmissionsIndexRoute
  '/transactions/': typeof TransactionsIndexRoute
  '/bench/plans/$planId': typeof BenchPlansPlanIdRoute
  '/bench/plans/new': typeof BenchPlansNewRoute
  '/bench/runs/$runId': typeof BenchRunsRunIdRoute
  '/financials/scenarios/$scenarioId': typeof FinancialsScenariosScenarioIdRoute
  '/financials/triage/$batchId': typeof FinancialsTriageBatchIdRoute
  '/bench/plans/': typeof BenchPlansIndexRoute
  '/bench/runs/': typeof BenchRunsIndexRoute
  '/financials/scenarios/': typeof FinancialsScenariosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/assets'
    | '/carbon-methodology'
    | '/custody-audit-records'
    | '/customs'
    | '/dashboard'
    | '/data-health'
    | '/direct-offers'
    | '/environmental'
    | '/financials'
    | '/individual-profile'
    | '/integrations'
    | '/inventory'
    | '/inventory-margin'
    | '/listings'
    | '/locations'
    | '/lots'
    | '/market-intelligence'
    | '/market-trends'
    | '/marketplace'
    | '/matches'
    | '/notifications'
    | '/offers'
    | '/onboarding'
    | '/opportunities'
    | '/passports'
    | '/privacy'
    | '/profile'
    | '/r2-controls'
    | '/signup'
    | '/submissions'
    | '/team'
    | '/terms'
    | '/tos'
    | '/transactions'
    | '/verification-links'
    | '/assets/$assetId'
    | '/assets/submit'
    | '/auth/callback'
    | '/bench/pair'
    | '/environmental/circularity'
    | '/environmental/fleet-detail'
    | '/environmental/reports'
    | '/financials/asset-financials'
    | '/financials/book-vs-fmv'
    | '/financials/depreciation'
    | '/financials/opportunity'
    | '/financials/policy'
    | '/financials/scenarios'
    | '/financials/setup'
    | '/financials/sustainability'
    | '/import/$batchId'
    | '/listings/$listingId'
    | '/lots/$lotId'
    | '/market-intelligence/$analysisId'
    | '/market-intelligence/cost-settings'
    | '/passport/$fingerprint'
    | '/submissions/$submissionId'
    | '/transactions/$transactionId'
    | '/assets/'
    | '/environmental/'
    | '/financials/'
    | '/market-intelligence/'
    | '/submissions/'
    | '/transactions/'
    | '/bench/plans/$planId'
    | '/bench/plans/new'
    | '/bench/runs/$runId'
    | '/financials/scenarios/$scenarioId'
    | '/financials/triage/$batchId'
    | '/bench/plans/'
    | '/bench/runs/'
    | '/financials/scenarios/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/carbon-methodology'
    | '/custody-audit-records'
    | '/customs'
    | '/dashboard'
    | '/data-health'
    | '/direct-offers'
    | '/individual-profile'
    | '/integrations'
    | '/inventory'
    | '/inventory-margin'
    | '/listings'
    | '/locations'
    | '/lots'
    | '/market-trends'
    | '/marketplace'
    | '/matches'
    | '/notifications'
    | '/offers'
    | '/onboarding'
    | '/opportunities'
    | '/passports'
    | '/privacy'
    | '/profile'
    | '/r2-controls'
    | '/signup'
    | '/team'
    | '/terms'
    | '/tos'
    | '/verification-links'
    | '/assets/$assetId'
    | '/assets/submit'
    | '/auth/callback'
    | '/bench/pair'
    | '/environmental/circularity'
    | '/environmental/fleet-detail'
    | '/environmental/reports'
    | '/financials/asset-financials'
    | '/financials/book-vs-fmv'
    | '/financials/depreciation'
    | '/financials/opportunity'
    | '/financials/policy'
    | '/financials/setup'
    | '/financials/sustainability'
    | '/import/$batchId'
    | '/listings/$listingId'
    | '/lots/$lotId'
    | '/market-intelligence/$analysisId'
    | '/market-intelligence/cost-settings'
    | '/passport/$fingerprint'
    | '/submissions/$submissionId'
    | '/transactions/$transactionId'
    | '/assets'
    | '/environmental'
    | '/financials'
    | '/market-intelligence'
    | '/submissions'
    | '/transactions'
    | '/bench/plans/$planId'
    | '/bench/plans/new'
    | '/bench/runs/$runId'
    | '/financials/scenarios/$scenarioId'
    | '/financials/triage/$batchId'
    | '/bench/plans'
    | '/bench/runs'
    | '/financials/scenarios'
  id:
    | '__root__'
    | '/'
    | '/assets'
    | '/carbon-methodology'
    | '/custody-audit-records'
    | '/customs'
    | '/dashboard'
    | '/data-health'
    | '/direct-offers'
    | '/environmental'
    | '/financials'
    | '/individual-profile'
    | '/integrations'
    | '/inventory'
    | '/inventory-margin'
    | '/listings'
    | '/locations'
    | '/lots'
    | '/market-intelligence'
    | '/market-trends'
    | '/marketplace'
    | '/matches'
    | '/notifications'
    | '/offers'
    | '/onboarding'
    | '/opportunities'
    | '/passports'
    | '/privacy'
    | '/profile'
    | '/r2-controls'
    | '/signup'
    | '/submissions'
    | '/team'
    | '/terms'
    | '/tos'
    | '/transactions'
    | '/verification-links'
    | '/assets/$assetId'
    | '/assets/submit'
    | '/auth/callback'
    | '/bench/pair'
    | '/environmental/circularity'
    | '/environmental/fleet-detail'
    | '/environmental/reports'
    | '/financials/asset-financials'
    | '/financials/book-vs-fmv'
    | '/financials/depreciation'
    | '/financials/opportunity'
    | '/financials/policy'
    | '/financials/scenarios'
    | '/financials/setup'
    | '/financials/sustainability'
    | '/import/$batchId'
    | '/listings_/$listingId'
    | '/lots_/$lotId'
    | '/market-intelligence/$analysisId'
    | '/market-intelligence/cost-settings'
    | '/passport/$fingerprint'
    | '/submissions/$submissionId'
    | '/transactions/$transactionId'
    | '/assets/'
    | '/environmental/'
    | '/financials/'
    | '/market-intelligence/'
    | '/submissions/'
    | '/transactions/'
    | '/bench/plans/$planId'
    | '/bench/plans/new'
    | '/bench/runs/$runId'
    | '/financials/scenarios/$scenarioId'
    | '/financials/triage/$batchId'
    | '/bench/plans/'
    | '/bench/runs/'
    | '/financials/scenarios/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AssetsRoute: typeof AssetsRouteWithChildren
  CarbonMethodologyRoute: typeof CarbonMethodologyRoute
  CustodyAuditRecordsRoute: typeof CustodyAuditRecordsRoute
  CustomsRoute: typeof CustomsRoute
  DashboardRoute: typeof DashboardRoute
  DataHealthRoute: typeof DataHealthRoute
  DirectOffersRoute: typeof DirectOffersRoute
  EnvironmentalRoute: typeof EnvironmentalRouteWithChildren
  FinancialsRoute: typeof FinancialsRouteWithChildren
  IndividualProfileRoute: typeof IndividualProfileRoute
  IntegrationsRoute: typeof IntegrationsRoute
  InventoryRoute: typeof InventoryRoute
  InventoryMarginRoute: typeof InventoryMarginRoute
  ListingsRoute: typeof ListingsRoute
  LocationsRoute: typeof LocationsRoute
  LotsRoute: typeof LotsRoute
  MarketIntelligenceRoute: typeof MarketIntelligenceRouteWithChildren
  MarketTrendsRoute: typeof MarketTrendsRoute
  MarketplaceRoute: typeof MarketplaceRoute
  MatchesRoute: typeof MatchesRoute
  NotificationsRoute: typeof NotificationsRoute
  OffersRoute: typeof OffersRoute
  OnboardingRoute: typeof OnboardingRoute
  OpportunitiesRoute: typeof OpportunitiesRoute
  PassportsRoute: typeof PassportsRoute
  PrivacyRoute: typeof PrivacyRoute
  ProfileRoute: typeof ProfileRoute
  R2ControlsRoute: typeof R2ControlsRoute
  SignupRoute: typeof SignupRoute
  SubmissionsRoute: typeof SubmissionsRouteWithChildren
  TeamRoute: typeof TeamRoute
  TermsRoute: typeof TermsRoute
  TosRoute: typeof TosRoute
  TransactionsRoute: typeof TransactionsRouteWithChildren
  VerificationLinksRoute: typeof VerificationLinksRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  BenchPairRoute: typeof BenchPairRoute
  ImportBatchIdRoute: typeof ImportBatchIdRoute
  ListingsListingIdRoute: typeof ListingsListingIdRoute
  LotsLotIdRoute: typeof LotsLotIdRoute
  PassportFingerprintRoute: typeof PassportFingerprintRoute
  BenchPlansPlanIdRoute: typeof BenchPlansPlanIdRoute
  BenchPlansNewRoute: typeof BenchPlansNewRoute
  BenchRunsRunIdRoute: typeof BenchRunsRunIdRoute
  BenchPlansIndexRoute: typeof BenchPlansIndexRoute
  BenchRunsIndexRoute: typeof BenchRunsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verification-links': {
      id: '/verification-links'
      path: '/verification-links'
      fullPath: '/verification-links'
      preLoaderRoute: typeof VerificationLinksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transactions': {
      id: '/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof TransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tos': {
      id: '/tos'
      path: '/tos'
      fullPath: '/tos'
      preLoaderRoute: typeof TosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team': {
      id: '/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof TeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/submissions': {
      id: '/submissions'
      path: '/submissions'
      fullPath: '/submissions'
      preLoaderRoute: typeof SubmissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r2-controls': {
      id: '/r2-controls'
      path: '/r2-controls'
      fullPath: '/r2-controls'
      preLoaderRoute: typeof R2ControlsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/passports': {
      id: '/passports'
      path: '/passports'
      fullPath: '/passports'
      preLoaderRoute: typeof PassportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opportunities': {
      id: '/opportunities'
      path: '/opportunities'
      fullPath: '/opportunities'
      preLoaderRoute: typeof OpportunitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offers': {
      id: '/offers'
      path: '/offers'
      fullPath: '/offers'
      preLoaderRoute: typeof OffersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/matches': {
      id: '/matches'
      path: '/matches'
      fullPath: '/matches'
      preLoaderRoute: typeof MatchesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketplace': {
      id: '/marketplace'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof MarketplaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/market-trends': {
      id: '/market-trends'
      path: '/market-trends'
      fullPath: '/market-trends'
      preLoaderRoute: typeof MarketTrendsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/market-intelligence': {
      id: '/market-intelligence'
      path: '/market-intelligence'
      fullPath: '/market-intelligence'
      preLoaderRoute: typeof MarketIntelligenceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lots': {
      id: '/lots'
      path: '/lots'
      fullPath: '/lots'
      preLoaderRoute: typeof LotsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/locations': {
      id: '/locations'
      path: '/locations'
      fullPath: '/locations'
      preLoaderRoute: typeof LocationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/listings': {
      id: '/listings'
      path: '/listings'
      fullPath: '/listings'
      preLoaderRoute: typeof ListingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory-margin': {
      id: '/inventory-margin'
      path: '/inventory-margin'
      fullPath: '/inventory-margin'
      preLoaderRoute: typeof InventoryMarginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory': {
      id: '/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof InventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations': {
      id: '/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof IntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/individual-profile': {
      id: '/individual-profile'
      path: '/individual-profile'
      fullPath: '/individual-profile'
      preLoaderRoute: typeof IndividualProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/financials': {
      id: '/financials'
      path: '/financials'
      fullPath: '/financials'
      preLoaderRoute: typeof FinancialsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/environmental': {
      id: '/environmental'
      path: '/environmental'
      fullPath: '/environmental'
      preLoaderRoute: typeof EnvironmentalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/direct-offers': {
      id: '/direct-offers'
      path: '/direct-offers'
      fullPath: '/direct-offers'
      preLoaderRoute: typeof DirectOffersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-health': {
      id: '/data-health'
      path: '/data-health'
      fullPath: '/data-health'
      preLoaderRoute: typeof DataHealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customs': {
      id: '/customs'
      path: '/customs'
      fullPath: '/customs'
      preLoaderRoute: typeof CustomsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/custody-audit-records': {
      id: '/custody-audit-records'
      path: '/custody-audit-records'
      fullPath: '/custody-audit-records'
      preLoaderRoute: typeof CustodyAuditRecordsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/carbon-methodology': {
      id: '/carbon-methodology'
      path: '/carbon-methodology'
      fullPath: '/carbon-methodology'
      preLoaderRoute: typeof CarbonMethodologyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets': {
      id: '/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof AssetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transactions/': {
      id: '/transactions/'
      path: '/'
      fullPath: '/transactions/'
      preLoaderRoute: typeof TransactionsIndexRouteImport
      parentRoute: typeof TransactionsRoute
    }
    '/submissions/': {
      id: '/submissions/'
      path: '/'
      fullPath: '/submissions/'
      preLoaderRoute: typeof SubmissionsIndexRouteImport
      parentRoute: typeof SubmissionsRoute
    }
    '/market-intelligence/': {
      id: '/market-intelligence/'
      path: '/'
      fullPath: '/market-intelligence/'
      preLoaderRoute: typeof MarketIntelligenceIndexRouteImport
      parentRoute: typeof MarketIntelligenceRoute
    }
    '/financials/': {
      id: '/financials/'
      path: '/'
      fullPath: '/financials/'
      preLoaderRoute: typeof FinancialsIndexRouteImport
      parentRoute: typeof FinancialsRoute
    }
    '/environmental/': {
      id: '/environmental/'
      path: '/'
      fullPath: '/environmental/'
      preLoaderRoute: typeof EnvironmentalIndexRouteImport
      parentRoute: typeof EnvironmentalRoute
    }
    '/assets/': {
      id: '/assets/'
      path: '/'
      fullPath: '/assets/'
      preLoaderRoute: typeof AssetsIndexRouteImport
      parentRoute: typeof AssetsRoute
    }
    '/transactions/$transactionId': {
      id: '/transactions/$transactionId'
      path: '/$transactionId'
      fullPath: '/transactions/$transactionId'
      preLoaderRoute: typeof TransactionsTransactionIdRouteImport
      parentRoute: typeof TransactionsRoute
    }
    '/submissions/$submissionId': {
      id: '/submissions/$submissionId'
      path: '/$submissionId'
      fullPath: '/submissions/$submissionId'
      preLoaderRoute: typeof SubmissionsSubmissionIdRouteImport
      parentRoute: typeof SubmissionsRoute
    }
    '/passport/$fingerprint': {
      id: '/passport/$fingerprint'
      path: '/passport/$fingerprint'
      fullPath: '/passport/$fingerprint'
      preLoaderRoute: typeof PassportFingerprintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/market-intelligence/cost-settings': {
      id: '/market-intelligence/cost-settings'
      path: '/cost-settings'
      fullPath: '/market-intelligence/cost-settings'
      preLoaderRoute: typeof MarketIntelligenceCostSettingsRouteImport
      parentRoute: typeof MarketIntelligenceRoute
    }
    '/market-intelligence/$analysisId': {
      id: '/market-intelligence/$analysisId'
      path: '/$analysisId'
      fullPath: '/market-intelligence/$analysisId'
      preLoaderRoute: typeof MarketIntelligenceAnalysisIdRouteImport
      parentRoute: typeof MarketIntelligenceRoute
    }
    '/lots_/$lotId': {
      id: '/lots_/$lotId'
      path: '/lots/$lotId'
      fullPath: '/lots/$lotId'
      preLoaderRoute: typeof LotsLotIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/listings_/$listingId': {
      id: '/listings_/$listingId'
      path: '/listings/$listingId'
      fullPath: '/listings/$listingId'
      preLoaderRoute: typeof ListingsListingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import/$batchId': {
      id: '/import/$batchId'
      path: '/import/$batchId'
      fullPath: '/import/$batchId'
      preLoaderRoute: typeof ImportBatchIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/financials/sustainability': {
      id: '/financials/sustainability'
      path: '/sustainability'
      fullPath: '/financials/sustainability'
      preLoaderRoute: typeof FinancialsSustainabilityRouteImport
      parentRoute: typeof FinancialsRoute
    }
    '/financials/setup': {
      id: '/financials/setup'
      path: '/setup'
      fullPath: '/financials/setup'
      preLoaderRoute: typeof FinancialsSetupRouteImport
      parentRoute: typeof FinancialsRoute
    }
    '/financials/scenarios': {
      id: '/financials/scenarios'
      path: '/scenarios'
      fullPath: '/financials/scenarios'
      preLoaderRoute: typeof FinancialsScenariosRouteImport
      parentRoute: typeof FinancialsRoute
    }
    '/financials/policy': {
      id: '/financials/policy'
      path: '/policy'
      fullPath: '/financials/policy'
      preLoaderRoute: typeof FinancialsPolicyRouteImport
      parentRoute: typeof FinancialsRoute
    }
    '/financials/opportunity': {
      id: '/financials/opportunity'
      path: '/opportunity'
      fullPath: '/financials/opportunity'
      preLoaderRoute: typeof FinancialsOpportunityRouteImport
      parentRoute: typeof FinancialsRoute
    }
    '/financials/depreciation': {
      id: '/financials/depreciation'
      path: '/depreciation'
      fullPath: '/financials/depreciation'
      preLoaderRoute: typeof FinancialsDepreciationRouteImport
      parentRoute: typeof FinancialsRoute
    }
    '/financials/book-vs-fmv': {
      id: '/financials/book-vs-fmv'
      path: '/book-vs-fmv'
      fullPath: '/financials/book-vs-fmv'
      preLoaderRoute: typeof FinancialsBookVsFmvRouteImport
      parentRoute: typeof FinancialsRoute
    }
    '/financials/asset-financials': {
      id: '/financials/asset-financials'
      path: '/asset-financials'
      fullPath: '/financials/asset-financials'
      preLoaderRoute: typeof FinancialsAssetFinancialsRouteImport
      parentRoute: typeof FinancialsRoute
    }
    '/environmental/reports': {
      id: '/environmental/reports'
      path: '/reports'
      fullPath: '/environmental/reports'
      preLoaderRoute: typeof EnvironmentalReportsRouteImport
      parentRoute: typeof EnvironmentalRoute
    }
    '/environmental/fleet-detail': {
      id: '/environmental/fleet-detail'
      path: '/fleet-detail'
      fullPath: '/environmental/fleet-detail'
      preLoaderRoute: typeof EnvironmentalFleetDetailRouteImport
      parentRoute: typeof EnvironmentalRoute
    }
    '/environmental/circularity': {
      id: '/environmental/circularity'
      path: '/circularity'
      fullPath: '/environmental/circularity'
      preLoaderRoute: typeof EnvironmentalCircularityRouteImport
      parentRoute: typeof EnvironmentalRoute
    }
    '/bench/pair': {
      id: '/bench/pair'
      path: '/bench/pair'
      fullPath: '/bench/pair'
      preLoaderRoute: typeof BenchPairRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets/submit': {
      id: '/assets/submit'
      path: '/submit'
      fullPath: '/assets/submit'
      preLoaderRoute: typeof AssetsSubmitRouteImport
      parentRoute: typeof AssetsRoute
    }
    '/assets/$assetId': {
      id: '/assets/$assetId'
      path: '/$assetId'
      fullPath: '/assets/$assetId'
      preLoaderRoute: typeof AssetsAssetIdRouteImport
      parentRoute: typeof AssetsRoute
    }
    '/financials/scenarios/': {
      id: '/financials/scenarios/'
      path: '/'
      fullPath: '/financials/scenarios/'
      preLoaderRoute: typeof FinancialsScenariosIndexRouteImport
      parentRoute: typeof FinancialsScenariosRoute
    }
    '/bench/runs/': {
      id: '/bench/runs/'
      path: '/bench/runs'
      fullPath: '/bench/runs/'
      preLoaderRoute: typeof BenchRunsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bench/plans/': {
      id: '/bench/plans/'
      path: '/bench/plans'
      fullPath: '/bench/plans/'
      preLoaderRoute: typeof BenchPlansIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/financials/triage/$batchId': {
      id: '/financials/triage/$batchId'
      path: '/triage/$batchId'
      fullPath: '/financials/triage/$batchId'
      preLoaderRoute: typeof FinancialsTriageBatchIdRouteImport
      parentRoute: typeof FinancialsRoute
    }
    '/financials/scenarios/$scenarioId': {
      id: '/financials/scenarios/$scenarioId'
      path: '/$scenarioId'
      fullPath: '/financials/scenarios/$scenarioId'
      preLoaderRoute: typeof FinancialsScenariosScenarioIdRouteImport
      parentRoute: typeof FinancialsScenariosRoute
    }
    '/bench/runs/$runId': {
      id: '/bench/runs/$runId'
      path: '/bench/runs/$runId'
      fullPath: '/bench/runs/$runId'
      preLoaderRoute: typeof BenchRunsRunIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bench/plans/new': {
      id: '/bench/plans/new'
      path: '/bench/plans/new'
      fullPath: '/bench/plans/new'
      preLoaderRoute: typeof BenchPlansNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bench/plans/$planId': {
      id: '/bench/plans/$planId'
      path: '/bench/plans/$planId'
      fullPath: '/bench/plans/$planId'
      preLoaderRoute: typeof BenchPlansPlanIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AssetsRouteChildren {
  AssetsAssetIdRoute: typeof AssetsAssetIdRoute
  AssetsSubmitRoute: typeof AssetsSubmitRoute
  AssetsIndexRoute: typeof AssetsIndexRoute
}

const AssetsRouteChildren: AssetsRouteChildren = {
  AssetsAssetIdRoute: AssetsAssetIdRoute,
  AssetsSubmitRoute: AssetsSubmitRoute,
  AssetsIndexRoute: AssetsIndexRoute,
}

const AssetsRouteWithChildren =
  AssetsRoute._addFileChildren(AssetsRouteChildren)

interface EnvironmentalRouteChildren {
  EnvironmentalCircularityRoute: typeof EnvironmentalCircularityRoute
  EnvironmentalFleetDetailRoute: typeof EnvironmentalFleetDetailRoute
  EnvironmentalReportsRoute: typeof EnvironmentalReportsRoute
  EnvironmentalIndexRoute: typeof EnvironmentalIndexRoute
}

const EnvironmentalRouteChildren: EnvironmentalRouteChildren = {
  EnvironmentalCircularityRoute: EnvironmentalCircularityRoute,
  EnvironmentalFleetDetailRoute: EnvironmentalFleetDetailRoute,
  EnvironmentalReportsRoute: EnvironmentalReportsRoute,
  EnvironmentalIndexRoute: EnvironmentalIndexRoute,
}

const EnvironmentalRouteWithChildren = EnvironmentalRoute._addFileChildren(
  EnvironmentalRouteChildren,
)

interface FinancialsScenariosRouteChildren {
  FinancialsScenariosScenarioIdRoute: typeof FinancialsScenariosScenarioIdRoute
  FinancialsScenariosIndexRoute: typeof FinancialsScenariosIndexRoute
}

const FinancialsScenariosRouteChildren: FinancialsScenariosRouteChildren = {
  FinancialsScenariosScenarioIdRoute: FinancialsScenariosScenarioIdRoute,
  FinancialsScenariosIndexRoute: FinancialsScenariosIndexRoute,
}

const FinancialsScenariosRouteWithChildren =
  FinancialsScenariosRoute._addFileChildren(FinancialsScenariosRouteChildren)

interface FinancialsRouteChildren {
  FinancialsAssetFinancialsRoute: typeof FinancialsAssetFinancialsRoute
  FinancialsBookVsFmvRoute: typeof FinancialsBookVsFmvRoute
  FinancialsDepreciationRoute: typeof FinancialsDepreciationRoute
  FinancialsOpportunityRoute: typeof FinancialsOpportunityRoute
  FinancialsPolicyRoute: typeof FinancialsPolicyRoute
  FinancialsScenariosRoute: typeof FinancialsScenariosRouteWithChildren
  FinancialsSetupRoute: typeof FinancialsSetupRoute
  FinancialsSustainabilityRoute: typeof FinancialsSustainabilityRoute
  FinancialsIndexRoute: typeof FinancialsIndexRoute
  FinancialsTriageBatchIdRoute: typeof FinancialsTriageBatchIdRoute
}

const FinancialsRouteChildren: FinancialsRouteChildren = {
  FinancialsAssetFinancialsRoute: FinancialsAssetFinancialsRoute,
  FinancialsBookVsFmvRoute: FinancialsBookVsFmvRoute,
  FinancialsDepreciationRoute: FinancialsDepreciationRoute,
  FinancialsOpportunityRoute: FinancialsOpportunityRoute,
  FinancialsPolicyRoute: FinancialsPolicyRoute,
  FinancialsScenariosRoute: FinancialsScenariosRouteWithChildren,
  FinancialsSetupRoute: FinancialsSetupRoute,
  FinancialsSustainabilityRoute: FinancialsSustainabilityRoute,
  FinancialsIndexRoute: FinancialsIndexRoute,
  FinancialsTriageBatchIdRoute: FinancialsTriageBatchIdRoute,
}

const FinancialsRouteWithChildren = FinancialsRoute._addFileChildren(
  FinancialsRouteChildren,
)

interface MarketIntelligenceRouteChildren {
  MarketIntelligenceAnalysisIdRoute: typeof MarketIntelligenceAnalysisIdRoute
  MarketIntelligenceCostSettingsRoute: typeof MarketIntelligenceCostSettingsRoute
  MarketIntelligenceIndexRoute: typeof MarketIntelligenceIndexRoute
}

const MarketIntelligenceRouteChildren: MarketIntelligenceRouteChildren = {
  MarketIntelligenceAnalysisIdRoute: MarketIntelligenceAnalysisIdRoute,
  MarketIntelligenceCostSettingsRoute: MarketIntelligenceCostSettingsRoute,
  MarketIntelligenceIndexRoute: MarketIntelligenceIndexRoute,
}

const MarketIntelligenceRouteWithChildren =
  MarketIntelligenceRoute._addFileChildren(MarketIntelligenceRouteChildren)

interface SubmissionsRouteChildren {
  SubmissionsSubmissionIdRoute: typeof SubmissionsSubmissionIdRoute
  SubmissionsIndexRoute: typeof SubmissionsIndexRoute
}

const SubmissionsRouteChildren: SubmissionsRouteChildren = {
  SubmissionsSubmissionIdRoute: SubmissionsSubmissionIdRoute,
  SubmissionsIndexRoute: SubmissionsIndexRoute,
}

const SubmissionsRouteWithChildren = SubmissionsRoute._addFileChildren(
  SubmissionsRouteChildren,
)

interface TransactionsRouteChildren {
  TransactionsTransactionIdRoute: typeof TransactionsTransactionIdRoute
  TransactionsIndexRoute: typeof TransactionsIndexRoute
}

const TransactionsRouteChildren: TransactionsRouteChildren = {
  TransactionsTransactionIdRoute: TransactionsTransactionIdRoute,
  TransactionsIndexRoute: TransactionsIndexRoute,
}

const TransactionsRouteWithChildren = TransactionsRoute._addFileChildren(
  TransactionsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AssetsRoute: AssetsRouteWithChildren,
  CarbonMethodologyRoute: CarbonMethodologyRoute,
  CustodyAuditRecordsRoute: CustodyAuditRecordsRoute,
  CustomsRoute: CustomsRoute,
  DashboardRoute: DashboardRoute,
  DataHealthRoute: DataHealthRoute,
  DirectOffersRoute: DirectOffersRoute,
  EnvironmentalRoute: EnvironmentalRouteWithChildren,
  FinancialsRoute: FinancialsRouteWithChildren,
  IndividualProfileRoute: IndividualProfileRoute,
  IntegrationsRoute: IntegrationsRoute,
  InventoryRoute: InventoryRoute,
  InventoryMarginRoute: InventoryMarginRoute,
  ListingsRoute: ListingsRoute,
  LocationsRoute: LocationsRoute,
  LotsRoute: LotsRoute,
  MarketIntelligenceRoute: MarketIntelligenceRouteWithChildren,
  MarketTrendsRoute: MarketTrendsRoute,
  MarketplaceRoute: MarketplaceRoute,
  MatchesRoute: MatchesRoute,
  NotificationsRoute: NotificationsRoute,
  OffersRoute: OffersRoute,
  OnboardingRoute: OnboardingRoute,
  OpportunitiesRoute: OpportunitiesRoute,
  PassportsRoute: PassportsRoute,
  PrivacyRoute: PrivacyRoute,
  ProfileRoute: ProfileRoute,
  R2ControlsRoute: R2ControlsRoute,
  SignupRoute: SignupRoute,
  SubmissionsRoute: SubmissionsRouteWithChildren,
  TeamRoute: TeamRoute,
  TermsRoute: TermsRoute,
  TosRoute: TosRoute,
  TransactionsRoute: TransactionsRouteWithChildren,
  VerificationLinksRoute: VerificationLinksRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  BenchPairRoute: BenchPairRoute,
  ImportBatchIdRoute: ImportBatchIdRoute,
  ListingsListingIdRoute: ListingsListingIdRoute,
  LotsLotIdRoute: LotsLotIdRoute,
  PassportFingerprintRoute: PassportFingerprintRoute,
  BenchPlansPlanIdRoute: BenchPlansPlanIdRoute,
  BenchPlansNewRoute: BenchPlansNewRoute,
  BenchRunsRunIdRoute: BenchRunsRunIdRoute,
  BenchPlansIndexRoute: BenchPlansIndexRoute,
  BenchRunsIndexRoute: BenchRunsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
